export const MAX_TRANSFER_HOURS = 6;

export const TRX_TYPE = {
  BUSINESS: "B2B",
  PERSONAL: "B2C"
};

export const NOTIFICATION_KEY = {
  DRAFT_BUNDLE: 1,
  EXCHANGE_RATE: 2
};

export const DISTURBANCE_TYPE = {
  UNPLANNED: "unplanned",
  PLANNED: "planned",
  HOLIDAY: "holiday"
};
